<template>
  <!-- 查看已读和未读人 -->
  <div @click="layoutClickEvent">
    <p class="p-l-10 l-h-30 f-w-bold r-t-l-4 r-t-r-4" style="background-color:#d9dde4;">消息接收人列表</p>
    <div class="c-fix" style="min-height:300px;">
      <div class="p-relative f-left w-50-p p-t-30">
        <p class="p-absolute top-0 left-0 w-100-p p-l-10 l-h-30 f-s-14"><span class="f-s-18">{{unreadAccounts.length}}</span>人未读</p>
        <div class="o-auto" style="max-height:340px;">
          <div class="m-r-5 p-l-10 p-y-5 l-h-20 f-s-12 cursor-pointer" v-for="member in unreadMembers" :key="member.account">
            <p style="display: flex;align-items: center;">
            <span v-if="member.account.length==32" style="display: inline-block;height: 40px;background: #653EB3;width: 40px; color: #fff;font-size: 12px; line-height: 40px;border-radius: 50%;text-align: center;transform: scale(0.7);">
            {{getShortNickname(member.nick)}}</span>
            <img v-if="member.account.length!=32&&member.nick!='小圆'" src="@/assets/images/im/kefu.svg"  style="display: inline-block;width:40px;height:40px;vertical-align: middle;transform: scale(0.7);"/>
            <img v-if="member.account.length!=32&&member.nick=='小圆'" src="@/assets/images/im/xiaoyuan.png"   style="display: inline-block;width:40px;height:40px;vertical-align: middle;transform: scale(0.7);"/>
            <span style="display: inline-block;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" v-if="member.account.length==32" class="cursor-pointer c-blue" :ref="member.account+'usernameRef'" @click.stop.self="getUserinfo(member.account)">{{member.nickInTeam?member.nickInTeam:member.nick}}{{member.tel?"-"+member.tel:""}}</span>
            <span v-else style="display: inline-block;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" class="cursor-pointer c-blue" :ref="member.account+'usernameRef'" @click.stop.self="getUserinfo(member.account)">{{member.nick}}{{JSON.parse(member.custom)?"-"+JSON.parse(member.custom).stationName:""}}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="p-relative f-left w-50-p p-t-30">
        <p class="p-absolute top-0 left-0 w-100-p p-l-10 l-h-30 f-s-14 c-blue"><span class="f-s-18">{{readAccounts.length}}</span>人已读</p>
        <div class="o-auto" style="max-height:340px;">
          <div class="m-r-5 p-l-10 p-y-5 l-h-20 f-s-12 cursor-pointer" v-for="member in readMembers" :key="member.account">
            <p style="display: flex;align-items: center;">
            <span v-if="member.account.length==32" style="display: inline-block;height: 40px;background: #653EB3;width: 40px; color: #fff;font-size: 12px; line-height: 40px;border-radius: 50%;text-align: center;transform: scale(0.7);">
            {{getShortNickname(member.nick)}}</span>
             <img v-if="member.account.length!=32&&member.nick!='小圆'" src="@/assets/images/im/kefu.svg"  style="display: inline-block;width:40px;height:40px;vertical-align: middle;transform: scale(0.7);"/>
            <img v-if="member.account.length!=32&&member.nick=='小圆'" src="@/assets/images/im/xiaoyuan.png"   style="display: inline-block;width:40px;height:40px;vertical-align: middle;transform: scale(0.7);"/>
            <span style="display: inline-block;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" v-if="member.account.length==32" class="cursor-pointer c-blue" :ref="member.account+'usernameRef'" @click.stop.self="getUserinfo(member.account)">{{member.nickInTeam?member.nickInTeam:member.nick}}{{member.tel?"-"+member.tel:""}}</span>
            <span v-else style="display: inline-block;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" class="cursor-pointer c-blue" :ref="member.account+'usernameRef'" @click.stop.self="getUserinfo(member.account)">{{member.nick}}{{JSON.parse(member.custom)?"-"+JSON.parse(member.custom).stationName:""}}</span></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    im: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data: function () {
    return {
      msg: null,
      unreadAccounts: [],
      readAccounts: [],
      unreadMembers: [],
      readMembers: []
    };
  },
  methods: {
    // 截取名称后俩位
    getShortNickname: function (name) {
      var len = name.length;
      return name.slice(len - 2, len);
    },
    // 获取群消息读取状态
    getTeamMsgReadAccounts: function (msg) {
      var $this = this;
      this.msg = msg;
      this.im.getTeamMsgReadAccounts({
        teamMsgReceipt: {
          teamId: msg.to,
          idServer: msg.idServer
        },
        done: function (error, obj, content) {
          if (content) {
            console.log("getTeamMsgReadAccounts",content);
            $this.unreadAccounts = content.unreadAccounts || 0;
            $this.readAccounts = content.readAccounts || 0;
            $this.getUserAccout(msg.to);
          }
        }
      });
    },
    getUserAccout: function (teamId) {
      // 未读信息人员列表
      var that = this;
      this.unreadMembers = [];
      this.readMembers = [];
      this.im.getTeamMembers({
        teamId:teamId,
        done: function (error, obj) {
          if(obj){
            if(that.unreadAccounts.length > 0){
              that.getIMUserInfomerber(that.unreadAccounts,obj.members,'unreadAccounts');

              // that.im.getUsers({
              //   accounts:that.unreadAccounts,
              //   done:function (error, users) {
              //     if(users){
              //       that.unreadMembers = users;
              //       that.addTeamNick(obj.members,that.unreadMembers);
              //       // console.log("unreadAccounts",that.unreadMembers);
              //     }
              //   }
              // })
            }
            if(that.readAccounts.length > 0){
              that.getIMUserInfomerber(that.readAccounts,obj.members,'readAccounts');

              // that.im.getUsers({
              //   accounts:that.readAccounts,
              //   done:function (error, users) {
              //     if(users){
              //       that.readMembers = users;
              //       that.addTeamNick(obj.members,that.readMembers);
              //       // console.log("readMembers",that.readMembers);
              //     }
              //   }
              // })
            }
          }
          // user.nickInTeam = obj[item.from].nickInTeam;
        }
      })
      
      // 已读信息人员列表
    },
    // 获取某个用户信息
    getIMUserInfomerber: function (userCode,members,readAccounts) {
      let index = 0;
      if(userCode&&userCode.length>50){
        let userCodeTemp = userCode.slice(index*50,++index*50);
        let lastuserCode = userCode.slice(index*50);
        this.getUsers(userCodeTemp,index,readAccounts,members);
        this.getIMUserInfomerber(lastuserCode,members,readAccounts);
      }else{
        this.getUsers(userCode,index,readAccounts,members);
      }
      
    },
    getUsers(userCode,index,readAccounts,members){
      var $this = this;
      this.im.getUsers({
        accounts: userCode,
        done: function (error, user) {
          
          if(user){
            if(readAccounts=='readAccounts'){
              console.log('user',user,'$this.readMembers',$this.readMembers)
              $this.readMembers.push(...user);
              $this.addTeamNick(members,user);
            }if(readAccounts=='unreadAccounts'){
              $this.unreadMembers.push(...user);
              $this.addTeamNick(members,user);
              console.log('$this.unreadMembers',$this.unreadMembers)
            }
           
          }
        }
      })
    },
    // 已读未读添加群昵称
    addTeamNick: function (teamMemberList,readList) {
      for(var i = 0; i < teamMemberList.length; i++) {
        for(var j = 0; j < readList.length;j++){
          if(teamMemberList[i].account === readList[j].account){
            if(teamMemberList[i].nickInTeam){
              this.$set(readList[j],"nickInTeam",teamMemberList[i].nickInTeam)
            } 
          }
        }
      }
    },
    // 获取联系人信息
    getMembers: function () {
      var $this = this;
      this.unreadMembers = [];
      this.unreadAccounts.forEach(function (element) {
        $this.getIMUserInfo(element, 'unreadMembers');
      });

      this.readMembers = [];
      this.readAccounts.forEach(function (element) {
        $this.getIMUserInfo(element, 'readMembers');
      });
    },
    // 获取某个用户信息
    getIMUserInfo: function (userCode, pro) {
      var $this = this;
      window.im_util_fn.get_user_info(userCode, function (user) {
        if (pro) $this[pro].push(user);
      });
    },
    // 查看联系人信息
    getUserinfo: function (userCode) {
      var context = this;
      var accounts = this.readAccounts.concat(this.unreadAccounts);
      accounts.forEach(function (element) {
        if (element === userCode) return;
        if (context.$refs[element + 'userinfoRef'] && context.$refs[element + 'userinfoRef'][0].visible) {
          context.$refs[element + 'userinfoRef'][0].destroy();
        }
      });
    },
    // 发消息
    sentMsg: function (user) {
      document.documentElement.click();
      this.$emit('createSession', user);
    },
    layoutClickEvent: function () {
      var context = this;
      var accounts = this.readAccounts.concat(this.unreadAccounts);
      accounts.forEach(function (element) {
        if (context.$refs[element + 'userinfoRef'] && context.$refs[element + 'userinfoRef'][0].visible) {
          context.$refs[element + 'userinfoRef'][0].destroy();
        }
      });
    }
  }
}
</script>
